<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 375 667"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="background-gradient"
  >
    <g opacity="0.5">
      <rect
        x="-180.908"
        y="177.204"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 -180.908 177.204)"
        class="darker-fill"
      />
      <rect
        x="-201"
        y="200.102"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 -201 200.102)"
        class="lighter-fill"
      />
      <rect
        x="311"
        y="267.102"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 311 267.102)"
        class="lighter-fill"
      />
      <rect
        x="287"
        y="267.204"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 287 267.204)"
        class="darker-fill"
      />
      <rect
        x="-236.908"
        y="547.204"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 -236.908 547.204)"
        class="darker-fill"
      />
      <rect
        x="-257"
        y="570.102"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 -257 570.102)"
        class="lighter-fill"
      />
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "../scss/variables.scss";

svg {
  min-width: 320px;
  position: absolute;
  background: linear-gradient(0deg, $primary 0, $primary-alternative 100%);
}

.lighter-fill {
  fill: $quaternary-darker;
}

.darker-fill {
  fill: $primary;
}

.gradient-initial-color {
  stop-color: $primary-alternative;
}

.gradient-final-color {
  stop-color: $primary;
}
</style>